module.exports = __webpack_public_path__ + "1a5b08cce3916612f34e0d08bd5ffc2e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/butterfly.svg
// module id = 81
// module chunks = 0